import React from 'react';
import { Tooltip as Tippy } from 'react-tippy';

import 'react-tippy/dist/tippy.css';
import './style.scss';

const Tooltip = ({
  html = <div></div>,
  position = 'top',
  trigger = 'mouseenter',
  arrow = true,
  children,
 ...props
}) => (
  <Tippy
    html={html}
    position={position}
    trigger={trigger}
    arrow={arrow}
    style={{display: 'flex', alignItems: 'center'}}
    {...props}
  >
    {children}
  </Tippy>
);

export default Tooltip;
